// @flow
import { createBulkCnTicketActions } from '../../createBulkCn/createBulkCnRedux/createBulkCnActionCreator';

const initialState = {
  jsonFile: null,
  counter: 0,
  postCallFailed: null
};

const createBulkCnReducer = (state: Object = initialState, action: Object) => {
  switch (action.type) {
    case createBulkCnTicketActions.CREATE_BULK_CN: {
      return Object.assign({}, state, action.payload);
    }

    default:
      return state;
  }
};

export default createBulkCnReducer;
